/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {CurrentUserQuery, CurrentUserQueryVariables} from '../types';

export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"loginAt"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isCommentsBlocked"}}]}}]}}]} as unknown as DocumentNode;
/** hook для запроса "CurrentUser" */
export function useCurrentUserQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
    return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(
        CurrentUserDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>),
    );
}
